"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouter = require("react-router");

var _PrivateRoute = _interopRequireDefault(require("../PrivateRoute"));

var Route = function Route(props) {
  var redirect = props.redirect,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["redirect"]);

  if (redirect) {
    return /*#__PURE__*/_react.default.createElement(_reactRouter.Redirect, (0, _extends2.default)({
      to: redirect
    }, restProps));
  }

  var auth = props.auth,
      subroutes = props.subroutes,
      otherProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["auth", "subroutes"]);

  if (auth) {
    return /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, props);
  }

  if (subroutes) {
    var component = otherProps.component,
        moreProps = (0, _objectWithoutPropertiesLoose2.default)(otherProps, ["component"]);
    var Component = component;
    return /*#__PURE__*/_react.default.createElement(_reactRouter.Route, (0, _extends2.default)({}, moreProps, {
      render: function render(routeProps) {
        var routes = subroutes.map(function (subrouteProps, index) {
          var path = subrouteProps.path,
              moreSubrouteProps = (0, _objectWithoutPropertiesLoose2.default)(subrouteProps, ["path"]);
          return /*#__PURE__*/_react.default.createElement(_reactRouter.Route, (0, _extends2.default)({}, moreSubrouteProps, {
            key: index,
            path: "" + routeProps.match.path + subrouteProps.path
          }));
        });
        return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, routeProps, {
          routes: routes
        }));
      }
    }));
  }

  return /*#__PURE__*/_react.default.createElement(_reactRouter.Route, props);
};

Route.propTypes = {
  auth: _PrivateRoute.default.propTypes.auth,
  location: _propTypes.default.object,
  redirect: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  subroutes: _propTypes.default.array
};
Route.displayName = 'Route';
var _default = Route;
exports.default = _default;